const StatisticDetail = ({title, headers, datas}) => {
    return (
            <div className="w-full px-3 mb-4">
                <div className="card h-auto w-full overflow-hidden">
                    <div className="card-header">
                        <h4 className="card-title mb-0 text-base">{title}</h4>
                    </div>
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-bordered align-middle mb-0 w-full">
                                <thead className="table-light text-muted">
                                    <tr>
                                        {headers.map((item, idx)=> (
                                            <th
                                                key={idx}
                                                scope="col"
                                                className={`px-3 py-2 ${idx === 0 ? "min-w-[220px] text-left" : "min-w-[88px] text-right"}`}
                                            >
                                                {item.name}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>

                                <tbody>
                                    {datas.map((item, idx) => (
                                        <tr key={idx}>
                                            {headers.map((_head, _hidx)=> (
                                                <td
                                                    key={_hidx}
                                                    className={`px-3 py-2 ${_hidx === 0 ? "max-w-[360px] whitespace-normal break-words text-left" : "whitespace-nowrap text-right tabular-nums"}`}
                                                >
                                                    {String(item[_head.id] ?? "")}
                                                </td>
                                            ))}
                                            {/* <td>{String(item["canceled_total"])} 원</td> */}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
    );
};

export default StatisticDetail;
